import DiagramWithToggleKey from "../shared/DiagramWithToggleKey";
import CardiometabolicNitricOxideCombined from "./index";

const CardiometabolicNitricOxideWithToggleKey = props => (
  <DiagramWithToggleKey
    CombinedDiagram={CardiometabolicNitricOxideCombined}
    keyControlsId="cardiometabolic-nitric-oxide-key"
    {...props}
  />
);

export default CardiometabolicNitricOxideWithToggleKey;
